/**
 * Converts an array of items into an object where each item is a key with a value of true.
 * Items that are falsy (except for 0) are ignored.
 */
export const fromArrToList = (arr: Array<any> = []): Record<string | number, boolean> => {
  if (!Array.isArray(arr)) {
    return {};
  }
  return arr.reduce((acc: Record<string | number, boolean>, item: any) => {
    if (item || typeof item === 'number') {
      acc[item] = true;
    }
    return acc;
  }, {});
};
